import React, {useEffect, useState} from 'react'
import {useIntl} from 'react-intl'
// import {toAbsoluteUrl} from '../../../../_metronic/helpers'
import {Formik} from 'formik'
import {Form} from 'react-bootstrap'
import {BasicButton} from '../../widgets/components/UI/BasicButton'
// import {useThemeMode} from '../../../../_metronic/partials'
import TextInput from '../../widgets/components/Input/TextInput'
import {useNavigate} from 'react-router-dom'
import {getLocation, getUserByToken} from '../core/_requests'
import * as Yup from 'yup'
import {toast} from 'react-toastify'
import {useAuth} from '../../auth/core/Auth'
import {verify2FA} from '../../auth/core/_requests'
import TagManager from 'react-gtm-module'
import {GTMEvent, loginSuccessMeta} from '../../../hooks/gtmHelpers'
import {removeNullFields} from '../../../core/_util'

const Verify2FA = () => {
  const {formatMessage} = useIntl()
  // const {mode} = useThemeMode()
  const [loading, setLoading] = useState(false)
  const [ipStackData, setIpStackData] = useState<any>()

  const navigate = useNavigate()
  const {
    saveAuth,
    setUserToken,
    storeCompanyId,
    setCompanyQueuePosition,
    setUseCase,
    setInvoiceStatus,
    setPlanStatus,
    twoFaToken,
    setTwoFaToken,
  } = useAuth()
  const isRecordskeeper = process.env.REACT_APP_BRAND === 'RK'

  const otpInitialValues = {
    code: '',
  }
  const verifyOtpSchema = Yup.object().shape({
    code: Yup.string()
      // .matches(/^\d{6}$/, 'OTP must be a 6-digit number')
      .required('Verification Code is required'),
  })

  useEffect(() => {
    const fetchIpStackData = async () => {
      try {
        const ipStackData = await getLocation()
        setIpStackData(ipStackData.data)
      } catch (err) {
        console.log(err)
      }
    }
    fetchIpStackData()
  }, []) // eslint-disable-line react-hooks/exhaustive-deps

  const verify2Fa = async (values: any) => {
    if (!values.code) return
    setLoading(true)
    try {
      const {
        data: {success, data, errors},
      } = await verify2FA(values.code, twoFaToken || '')
      if (success) {
        await saveAuth(data)
        setUserToken(data.token)
        localStorage.setItem('signUpCompany', data.signUpCompany)
        const {data: userData} = await getUserByToken(data.token)
        if (
          userData?.data?.defaultCompanyId !== null &&
          userData?.data?.defaultCompanyId !== undefined
        ) {
          const findCompany = userData?.data?.company?.find(
            (company: {companyId: number}) => company.companyId === userData?.data?.defaultCompanyId
          )
          if (findCompany) {
            storeCompanyId(userData?.data?.defaultCompanyId)
            setCompanyQueuePosition(findCompany?.queuePosition)
            setUseCase(findCompany?.useCase)
            if (userData?.data?.companyPlanStatus?.invoiceStatus) {
              setInvoiceStatus(userData.data.companyPlanStatus.invoiceStatus)
            }
            if (userData?.data?.companyPlanStatus?.planStatus) {
              setPlanStatus(userData.data.companyPlanStatus.planStatus)
            }
          }
        }

        TagManager.dataLayer({
          dataLayer: {
            event: GTMEvent.LoginSuccess,
            signup_method: 'Email',
            metadata: removeNullFields({
              country_name: ipStackData?.country_name || 'NA',
              region_name: ipStackData?.region_name || 'NA',
              city_name: ipStackData?.city || 'NA',
              postcode: ipStackData?.zip || 111111,
              ...loginSuccessMeta(userData.data),
            }),
          },
        })
        if (
          (userData?.data?.company?.length === 0 && isRecordskeeper) ||
          (!userData?.data?.contactVerifiedAt && isRecordskeeper) ||
          (!userData?.data?.contact && isRecordskeeper) ||
          (!userData?.data?.countryDialingCode && isRecordskeeper)
        ) {
          navigate('/auth/info')
        } else {
          navigate('/dashboard')
        }
        setTwoFaToken(undefined)
      } else {
        errors.forEach((error: string) => {
          toast.error(formatMessage({id: error}))
        })
      }
    } catch (err) {
      console.log(err)
    } finally {
      setLoading(false)
    }
  }

  return (
    <div>
      <div className=''>
        <div className='d-flex align-items-center justify-content-center h-100'>
          <div className='d-flex flex-column justify-content-center align-items-center otp-screen py-6 px-md-0 px-2 gap-6 w-100'>
            <div className='d-flex flex-column align-items-center justify-content-center gap-6 col-md-12 col-11'>
              <div>
                <h1 className='mb-0 text-center font-size-20 mb-4'>
                  {formatMessage({
                    id: `Verify 2-Factor Authentication`,
                  })}
                </h1>
                <p className='mb-0 text-center font-size-14 text-muted'>
                  {formatMessage({
                    id: `Enter the 6-digit code from your authenticator app or verify using a backup code to sign in securely to RecordsKeeper.AI`,
                  })}
                </p>
              </div>
            </div>
            <Formik
              initialValues={otpInitialValues}
              validationSchema={verifyOtpSchema}
              onSubmit={verify2Fa}
              validateOnMount
            >
              {(formik) => (
                <Form className='d-flex flex-column align-items-center gap-4 w-100'>
                  <div className='col-md-12 col-11'>
                    <TextInput
                      fieldType='text'
                      label={formatMessage({id: '2FA Verification Code'})}
                      fieldName='code'
                      formik={formik}
                      placeholder={formatMessage({id: 'Enter Code'})}
                      toolTipText={formatMessage({
                        id: 'Use your authenticator app (like Google Authenticator or Authy) to get the current 6-digit code.',
                      })}
                      isStarRequired={true}
                      isTooltipForModal={true}
                      onBlur={formik.handleBlur}
                      isMargin='mb-1'
                    />

                    <p className='m-0 text-muted'>
                      <span
                        className='text-primary cursor-pointer'
                        onClick={() => {
                          window.Intercom(
                            'showNewMessage',
                            'I need assistance resetting my 2FA for my account. Please advise on verification steps required to restore access.'
                          )
                        }}
                      >
                        {formatMessage({id: 'Forgot 2FA?'})}
                      </span>
                    </p>
                  </div>

                  <BasicButton
                    buttonText={formatMessage({id: 'Verify Now'})}
                    height='44px'
                    customClass='bg-primary text-white w-100'
                    padding='12px 24px'
                    loading={loading}
                    onClick={() => verify2Fa(formik.values)}
                  />

                  <BasicButton
                    buttonText={formatMessage({id: 'Cancel'})}
                    height='44px'
                    customClass='bg-secondary text-dark w-100'
                    padding='12px 24px'
                    loading={loading}
                    onClick={() => navigate('/')}
                  />
                </Form>
              )}
            </Formik>

            {/* <div>
              <p className='m-0 text-muted'>{formatMessage({id: 'lost access to your authenticator app?'})} </p>
              <p className='m-0 text-muted'>
                {' '}
                {formatMessage({id: 'Verify through backup code.'})}{' '}
                <span className='text-primary cursor-pointer' onClick={() => handleVerify()}>
                  {formatMessage({id: 'Verify Now'})}
                </span>
              </p>
            </div> */}
          </div>
        </div>
      </div>
    </div>
  )
}
export default Verify2FA
